import styled, { css } from '@xstyled/styled-components'
import { NavLinkWithPreload } from 'utilities/PreloadLinks'
import { filterComponent } from '@trybeapp/ui.system'
import { FontAwesomeIcon } from 'components/FontAwesomeIcon'
import { Text } from 'components/Text'
import { useLocation } from 'react-router-dom'

const linkStyles = () => css`
  color: primary.700;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0.5em;
  padding-left: 1rem;
  padding-right: 1rem;

  &.active {
    box-shadow: inset-sm-primary;
  }

  &:hover {
    text-decoration: none;
    background-color: primary.100;
  }
`

const NavLink = styled(filterComponent(NavLinkWithPreload))(css`
  ${linkStyles}
`)

export const TextLink = styled(filterComponent(Text))(css`
  cursor: pointer;
  ${linkStyles}
`)

/* & + & {
  margin-left: 2em;
} */

const Preload = (item) => {
  if (item && item.preload) {
    item.preload()
  }
}

export const NavItem = ({ to, faIcon, text, preload }) => {
  return (
    <NavLink exact to={to} onMouseEnter={() => Preload(preload)}>
      <FontAwesomeIcon fixedWidth icon={faIcon} mr={2} />
      {text}
    </NavLink>
  )
}

export const SmallNavItem = ({ to, children }) => {
  const location = useLocation()
  const isActive = location.pathname === to

  return (
    <NavLinkWithPreload to={to}>
      <SmallNavItemText isActive={isActive}>{children}</SmallNavItemText>
    </NavLinkWithPreload>
  )
}

export const SmallNavItemText = ({ children, isActive, ...props }) => (
  <Text
    px="md"
    variant="body3"
    as="span"
    color={isActive ? 'nude.900' : 'nude.700'}
    minHeight={40}
    display="flex"
    alignItems="center"
    fontWeight={isActive ? 'bold' : null}
    borderBottomColor="primary.100"
    {...props}
  >
    {children}
  </Text>
)

export default NavItem
